import script from "./adminHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./adminHeader.vue?vue&type=script&setup=true&lang=ts"

import "./adminHeader.vue?vue&type=style&index=0&id=39981174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39981174"]])

export default __exports__